import { render, staticRenderFns } from "./CategoryResource.vue?vue&type=template&id=5fbf4aaa"
import script from "./CategoryResource.vue?vue&type=script&lang=js"
export * from "./CategoryResource.vue?vue&type=script&lang=js"
import style0 from "./CategoryResource.vue?vue&type=style&index=0&id=5fbf4aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports